import { importLibrary, setOptions } from '@googlemaps/js-api-loader';

let ready: Promise<typeof google> | null = null;

/**
 * Singleton to ensure Google Maps API loads only once
 * Call this before using any Google Maps features
 */
export function ensureGoogleMaps(apiKey: string): Promise<typeof google> {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('No window (SSR)'));
  }

  const g: any = (window as any).google;

  // Already bootstrapped: google.maps exists and importLibrary is callable
  if (g?.maps && typeof g.maps.importLibrary === 'function') {
    return Promise.resolve(g as typeof google);
  }

  // Already loading
  if (ready) {
    return ready;
  }

  // Set options ONCE; subsequent calls are ignored by the lib
  setOptions({ key: apiKey, v: 'weekly' });

  // Load the libraries we need (parallel) then return the global google
  ready = Promise.all([
    importLibrary('maps'),
    importLibrary('marker'), // For AdvancedMarkerElement, PinElement
  ]).then(() => (window as any).google as typeof google);

  return ready;
}
